// framework/common/schemas/collections/workflows.js
import { z } from "zod";

// Schema for individual tools within a workflow
const WorkflowToolSchema = z.object({
  instanceId: z.string().describe("Unique ID for this tool instance within the workflow."),
  className: z.string().describe("Name of the tool class (e.g., 'EmailTool', 'HttpTool')."),
  properties: z.record(z.string(), z.any()).optional().describe("Configuration properties for the tool instance."),
  name: z.string().describe("Display name of the tool"),
  connections: z.record(z.string(), z.string()).optional().describe("Connections to other tools.  Key is the output name, value is the target tool's instanceId."),
  x: z.number().optional().describe("X position of the tool in the visual editor."),
  y: z.number().optional().describe("Y position of the tool in the visual editor."),
});

// Schema for the entire workflow
const WorkflowSchema = z.object({
  _id: z.string().optional(),
  name: z.string().min(1).describe("Unique name of the workflow."),
  description: z.string().optional().describe("Description of the workflow."),
  tools: z.array(WorkflowToolSchema).describe("Array of tool instances in the workflow."),
  enabled: z.boolean().default(true).describe("Whether the workflow is enabled or disabled."),
  category: z.enum(["system", "user"]).default("user").describe("Category of the workflow (system or user)."),
  context: z.object({}).passthrough().optional().describe("Context data for the workflow."),
  events: z.string().optional().describe("List of events that can trigger this workflow."),
  tags: z.array(z.string()).optional().default([]).describe("Tags for categorizing and filtering workflows."),

  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
  schema: z.any().optional().describe("Zod schema for input parameters to the workflow."),
});

export default WorkflowSchema;